<ng-template #sidebarSkeleton>
    <app-sidebar-skeleton-loader></app-sidebar-skeleton-loader>
</ng-template>

<div *ngIf="!(isSidebarLoading$ | async) && sideNavData else sidebarSkeleton;" class="sidebar">
    <span>
        <div class="account-block">
            <div [class.hide-avatar]="!sideNavData.orgLogo" class="avatar-img">
                <img *ngIf="sideNavData.orgLogo" id="avatar" [src]="sideNavData.orgLogo" [alt]="sideNavData.orgName" />
            </div>
            <div class="mat-headline-6">{{ sideNavData.orgName }}</div>
            <div class="mat-body-strong">{{ sideNavData.email }}</div>
        </div>
        <div class="line"></div>
        <ul class="nav nav-pills flex-column">
            <ng-container *ngFor="let navData of navigationLinks.navs">
                <ng-container *ngIf="navData.subRoutes?.length; else listItemNavTempRef">
                    <ng-container *ngTemplateOutlet="expNavDataTemp; context: {data: navData}"></ng-container>
                </ng-container>

                <ng-template #listItemNavTempRef>
                    <ng-container *ngTemplateOutlet="listItemNavTemp; context: {data: navData}"></ng-container>
                </ng-template>
            </ng-container>
        </ul>
        <ng-container *ngIf="navigationLinks.admin?.length">
        <div class="line"></div>

        <ul class="nav nav-pills flex-column">
            <p class="mat-body-strong ml-15 mb-16">Admin</p>
                <ng-container *ngFor="let navData of navigationLinks.admin">
                    <ng-container *ngIf="navData.subRoutes?.length; else listItemNavTempRef">
                        <ng-container *ngTemplateOutlet="expNavDataTemp; context: {data: navData}"></ng-container>
                    </ng-container>
                    
                    <ng-template #listItemNavTempRef>
                        <ng-container *ngTemplateOutlet="listItemNavTemp; context: {data: navData}"></ng-container>
                    </ng-template>
                </ng-container>
            </ul>
        </ng-container>
    </span>

    <span>
        <ng-container *ngIf="navigationLinks.system?.length">
        <div class="line"></div>
        <ul class="nav nav-pills flex-column mb-8">
                <ng-container *ngFor="let navData of navigationLinks.system">
                    <ng-container *ngIf="navData.subRoutes?.length; else listItemNavTempRef">
                        <ng-container *ngTemplateOutlet="expNavDataTemp; context: {data: navData}"></ng-container>
                    </ng-container>
                    
                    <ng-template #listItemNavTempRef>
                        <ng-container *ngTemplateOutlet="listItemNavTemp; context: {data: navData}"></ng-container>
                    </ng-template>
                </ng-container>
            </ul>
        </ng-container>

        <!-- FOOTER LINKS BLOCK -->
        <div class="line"></div>
        <div class="d-flex align-items-center p-16 pl-24">
            <a 
                href="https://gobloominghealth.com/terms-of-service/" 
                target="_blank" 
                class="mat-caption text-hint mr-4"
                >Terms of Service</a>
            <div class="text-disabled">|</div>
            <a 
                href="https://gobloominghealth.com/privacy-policy/" 
                target="_blank" 
                class="mat-caption text-hint ml-4"
                >Privacy Policy</a>
        </div>
    </span>
</div>

<ng-template #expNavDataTemp let-navData="data">
    <li class="nav-item expansion-item" *ngIf="!isAllSubRoutesHidden(navData.subRoutes)">
        <mat-expansion-panel *ngIf="isNavVisible(navData.featureName)"   class="mat-elevation-z0 body-p-0" #navExp>
            <mat-expansion-panel-header class="indicator-28 pl-0 pr-16">
                <a 
                    [routerLink]="navData.route" 
                    routerLinkActive="active" 
                    class="nav-link d-flex"
                    [class.text-disabled]="isDisabledRoute(navData.route) || navData.isDisabled"
                >
                    <mat-icon [ngClass]="{'material-icons-outlined': !navData.iconSymbol, 'material-symbols-outlined': navData.iconSymbol}">{{navData.icon}}</mat-icon>
                    <span class="ml-32">{{navData.label}}</span>
                </a>
            </mat-expansion-panel-header>
        
            <ul>
                <li *ngFor="let subNavData of navData.subRoutes" [hidden]="subNavData.isHidden">
                    <a 
                        *ngIf="subNavData?.linkActiveCheck?.length; else routerLinActiveTemp" 
                        [routerLink]="subNavData.route" 
                        class="nav-link" 
                        [class.active]="isLinkActive(subNavData.linkActiveCheck)"
                        [class.text-disabled]="isDisabledRoute(navData.route)|| isDisabledRoute(subNavData.route) || subNavData.isDisabled"
                    >
                        <span class="ml-56 pl-24">{{subNavData.label}}</span>
                    </a>
                    <ng-template #routerLinActiveTemp>
                        <a 
                            [routerLink]="subNavData.route" 
                            routerLinkActive="active" 
                            class="nav-link" 
                            [class.text-disabled]="isDisabledRoute(navData.route) || isDisabledRoute(subNavData.route) || subNavData.isDisabled"
                        >
                            <span class="ml-56 pl-24">{{subNavData.label}}</span>
                        </a>
                    </ng-template>
                </li>
            </ul>
        </mat-expansion-panel>
    </li>
</ng-template>

<ng-template #listItemNavTemp let-navData="data">
    <li class="nav-item">
        <a
            [routerLink]="navData.route"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: !!navData.exactActiveCheck }"
            [class]="'nav-link'" 
            [class.text-disabled]="isDisabledRoute(navData.route) || navData.isDisabled"
            aria-current="page"
        >
            <mat-icon class="material-icons-outlined">{{navData.icon}}</mat-icon>
            <span class="ml-32">{{navData.label}}</span>
        </a>
    </li>
</ng-template>